import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormlyModule } from '@ngx-formly/core';
import {
    AbstractControl,
    FormsModule,
    ReactiveFormsModule,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormlyFieldButton } from './Formly/custom-types/button-type.component';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { NavbarComponent } from './component/navbar/navbar.component';
import { SidebarModule } from 'primeng/sidebar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuModule } from 'primeng/menu';
import { CommonModule } from '@angular/common';
// import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ChipModule } from 'primeng/chip';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarToggleButtonComponent } from './component/navbar/sidebar-toggle-button/sidebar-toggle-button.component';
import { CountryInterceptor } from './shared/Interceptors/countryInterceptors/country.interceptor';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule } from './module/shared/shared.module';
import { CustomToastComponent } from './component/custom-toast/custom-toast.component';
import { AuthInterceptor } from './shared/auth.interceptor';
import { ProfileComponent } from './module/profile/profile.component';
import { TabViewModule } from 'primeng/tabview';
import { FormlyFieldFileUploadComponent } from './module/users/types/formly-field-file-upload.component';
import { PasswordComponent } from './module/password/password.component';
import { FormlyHorizontalWrapper } from './horizontal-wrappers';
import { MessagesModule } from 'primeng/messages';
import { FormlyFieldPhotoUploadComponent } from './module/users/types/profilepicture-type';
import { TooltipModule } from 'primeng/tooltip';
import { UnderConstructionComponent } from './page404/under-construction/under-construction.component';
import { TokenInterceptor } from './shared/token.interceptor';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { FormlyFieldMultiFile } from './module/service-provider/multiFile-type';
import { FormlyFieldFile } from './module/service-provider/file-type';
import { CustomCheckboxComponent } from './module/service-provider/custom-checkbox';
import { SliderModule } from 'primeng/slider';
import { DistributorWalletComponent } from './component/distributor-wallet/distributor-wallet.component';
import { CalendarModule } from 'primeng/calendar';
import { LoaderInterceptor } from './shared/Interceptors/Loader/loader.interceptor';
import { LoaderComponent } from './component/loader/loader.component';
import { PdfViewerModule, } from 'ng2-pdf-viewer';
import { RechargeWalletPopupComponent } from './component/recharge-wallet-popup/recharge-wallet-popup.component';
import { WalletInterceptor } from './shared/Interceptors/Wallet/wallet.interceptor';
import { PermissionWrapperComponent } from './component/permission-wrapper/permission-wrapper.component';
import { UserDashboardModule } from './module/user-dashboard/user-dashboard.module';
import { PromotionDashboardComponent } from './component/promotion-dashboard/promotion-dashboard.component';
import { PromotionDashboardTabsComponent } from './component/promotion-dashboard/promotion-dashboard-tabs/promotion-dashboard-tabs.component';
import { PromotionAnalyticsComponent } from './component/promotion-analytics/promotion-analytics.component';
import { OtpPageComponent } from './otp-page/otp-page.component';
import { InputOtpModule } from 'primeng/inputotp';
import { OtpTypeComponent } from './otp-page/customType/otp-type.component';
import { NewpasswordComponent } from './otp-page/newpassword/newpassword.component';


@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        SidebarToggleButtonComponent,
        CustomToastComponent,
        ProfileComponent,
        PasswordComponent,
        FormlyHorizontalWrapper,
        FormlyFieldPhotoUploadComponent,
        UnderConstructionComponent,
        FormlyFieldMultiFile,
        FormlyFieldFile,
        CustomCheckboxComponent,
        DistributorWalletComponent,
        LoaderComponent,
        OtpPageComponent,
        OtpTypeComponent,
        NewpasswordComponent,
        
    ],
    exports: [],
    bootstrap: [AppComponent],
    imports: [
        SharedModule,
        TableModule,
        SliderModule,
        ConfirmDialogModule,
        LoadingBarHttpClientModule,
        TooltipModule,
        TabViewModule,
        IconFieldModule,
        InputTextModule,
        InputIconModule,
        BrowserModule,
        FormsModule,
        CommonModule,
        InputOtpModule,
        //SharedModule,
        PdfViewerModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormlyPrimeNGModule,
        AppRoutingModule,
        ButtonModule,
        MenubarModule,
        CardModule,
        ButtonModule,
        TableModule,
        DialogModule,
        ChipModule,
        ToastModule,
        CalendarModule,
        MessagesModule,
        // UserDashboardModule,
        //GoogleMapsModule
        FormlyModule.forChild({
            validationMessages: [
                { name: 'required', message: 'This field is required' },
                {
                    name: 'passwordStrength',
                    message: 'Password must be at least 6 characters long and contain at least one uppercase letter.',
                },
            ],
            validators:
                [
                    { name: 'passwordStrength', validation: passwordValidator }],
            wrappers:
                [
                    { name: 'form-field-horizontal', component: FormlyHorizontalWrapper },
                ],
            types:
                [
                    {
                        name: 'file-photoupload',
                        component: FormlyFieldPhotoUploadComponent,
                    },
                    { name: 'file', component: FormlyFieldFile, wrappers: ['form-field'] },
                    {
                        name: 'multifile',
                        component: FormlyFieldMultiFile,
                    },
                    { name: 'custom-checkbox', component: CustomCheckboxComponent },
                    { name: 'otp', component: OtpTypeComponent },
                ],
        }),
        SidebarModule,
        PanelMenuModule,
        MenuModule,
        FileUploadModule,
        ToastModule,
    ],
    providers:
        [
            ConfirmationService,
            MessageService,
            DynamicDialogRef,
            DialogService,
            ConfirmationService,
            {
                provide: HTTP_INTERCEPTORS,
                multi: true,
                useClass: CountryInterceptor,
            },
            {
                provide: HTTP_INTERCEPTORS,
                multi: true,
                useClass: TokenInterceptor,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: LoaderInterceptor,
                multi: true
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: WalletInterceptor,
                multi: true
            },
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class AppModule { }

// Custom Validator for Password Strength
export function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        // Check for minimum length
        const minLength = value.length >= 6;

        // Check for at least one uppercase letter
        const hasUpperCase = /[A-Z]/.test(value);

        const passwordValid = minLength && hasUpperCase;

        return !passwordValid ? { passwordStrength: true } : null;
    };
}
